import { useRef, useState } from "react";
import { Box } from "@mui/material";
import Text from "./text/Text";
import { useSelector } from "react-redux";
import { Input } from "./input/Input";
import {
  displayAmountWithCurrency,
  displayTaprootCurrency,
  getDisplayAmount,
} from "./constants";
import { sats, btc, XAUT } from "./messages";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import IconButton from "@mui/material/IconButton";
import CustomDivider from "./divider/Divider";

function EnterAmountBox({
  isFromBrowser,
  checkExchange,
  currentAmount,
  currentConvertedAmount,
  currentNote,
  setCurrentNote,
  setIsContentChanged,
  handleChangeCurrency,
  handleAmountChange,
  currency,
  from,
  isSelectedAmountOrNote,
  setIsSelectedAmountOrNote,
  isAmountEditable = true,
  selectedMethodName = null,
}) {
  const { walletCurrency, showBtcAmount } = useSelector(
    (state) => state.common
  );
  const { code: targetedCurrency, symbol: targetedCurrencySymbol } = {
    ...walletCurrency,
  };

  const inputRef = useRef();
  const [isEdit, setIsEdit] = useState(isAmountEditable);
  const [isBackSpace, setIsBackSpace] = useState(false);

  const textSize = 14;
  const showNote =
    (from === "payment" && selectedMethodName === "lightning") ||
    from === "withdraw";

  const displayAmount = (checkExchange, showSymbol = true) => {
    let displayAmt = 0;
    if (checkExchange) {
      displayAmt = getDisplayAmount(
        checkExchange,
        currentConvertedAmount,
        targetedCurrency
      );
    } else {
      displayAmt = getDisplayAmount(checkExchange, currentAmount, currency);
    }

    if (!showSymbol) return displayAmt;

    const displayCurrency = currency === sats && showBtcAmount ? btc : currency;
    return showSymbol
      ? displayAmountWithCurrency(
          checkExchange ? targetedCurrency : displayCurrency,
          displayAmt
        )
      : displayAmt;
  };

  return (
    <Box className="enter-amount-box" margin={isFromBrowser ? "0px" : "0px"}>
      <Box className="amount-box" mb={isFromBrowser ? "24px" : "12px"}>
        <Text className="default-text" size={16} font="regular">
          {checkExchange
            ? targetedCurrency
            : displayTaprootCurrency(currentAmount, currency)}
        </Text>

        {isEdit ? (
          <Input
            ref={inputRef}
            fullWidth
            placeholder={"0"}
            customClass={"amount-input"}
            autoFocus={isSelectedAmountOrNote === "amount" && true}
            name="amount"
            value={checkExchange ? currentConvertedAmount : currentAmount}
            type="number"
            onWheel={(e) => e.target.blur()}
            onKeyDown={(evt) => {
              let excludedKey = ["e", "E", "+", "-"];

              setIsBackSpace(evt.keyCode === 8); // Allow backspace

              if (!checkExchange && currency === sats && !showBtcAmount)
                excludedKey.push(".");

              if (excludedKey.includes(evt.key)) evt.preventDefault();
            }}
            onFocus={(e) => {
              setIsEdit(true);
              setIsSelectedAmountOrNote?.("amount");
              if (inputRef?.current) {
                e.target.type = "text";
                inputRef.current.selectionStart = inputRef.current.value.length;
                e.target.type = "number";
              }
            }}
            onBlur={() => setIsEdit(false)}
            onChange={(e) => {
              const isXAUT = currency === XAUT;
              const decimalPlaces = isXAUT ? 6 : 2;
              const pattern = new RegExp(`^\\d+(\\.\\d{0,${decimalPlaces}})?$`);

              let val = e.target.value;
              if (
                val &&
                !pattern.test(val) &&
                !isBackSpace &&
                (checkExchange || currency !== sats)
              ) {
                e.preventDefault();
              } else {
                handleAmountChange(e);
              }
            }}
            inputProps={{
              min: 0,
              style: {
                border: isEdit ? "1px solid #F6F3F3" : "none",
                height: "35px",
                padding: isFromBrowser ? "10px 12px" : "5px 12px",
              },
              pattern: "[0-9]*",
              inputMode: "decimal",
            }}
          />
        ) : (
          <>
            <Text
              size={isFromBrowser ? 44 : 34}
              font="medium"
              className={`default-text ${isAmountEditable && "cursor-pointer"}`}
              onClick={() => setIsEdit(isAmountEditable)}
            >
              {displayAmount(checkExchange, false)}
            </Text>
          </>
        )}
        <IconButton onClick={handleChangeCurrency}>
          <SyncAltIcon className="exchange-icon" sx={{ margin: "14px 0" }} />
        </IconButton>
        <Text size={24} font="regular" className="grey-text" variant="h6">
          {displayAmount(!checkExchange)}
        </Text>
      </Box>
      {showNote && from === "payment" && (
        <CustomDivider sx={{ width: "100%" }} />
      )}
      {showNote && (
        <Box className={"add-notes-options"}>
          <Input
            fullWidth={from === "payment"}
            autoFocus={isSelectedAmountOrNote === "note"}
            placeholder="+ Add a note"
            name="note"
            value={currentNote}
            type="text"
            onWheel={(e) => e.target.blur()}
            onChange={(e) => {
              from === "payment" && setIsContentChanged(true);
              setCurrentNote(e.target.value);
            }}
            inputProps={{
              maxLength: 100,
              style: {
                fontSize: textSize,
                backgroundColor: "#F7FAFC",
              },
            }}
            customClass={"send-note"}
          />
        </Box>
      )}
    </Box>
  );
}

export default EnterAmountBox;
